import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getTopper } from "../Service/Api";
const TopperX = () => {
  const [classXData, setClassXData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const topperData = await getTopper();

      const currentYear = new Date().getFullYear();
      const yearString = `${currentYear - 1}-${currentYear}`;

      // Filter data for class X
      let classX = topperData.filter(
        (item) => item.class === "X" && item.sessionYear === yearString,
      );

      if (classX.length === 0) {
        // Fallback: find the most recent year with data
        const uniqueYears = Array.from(
          new Set(
            topperData
              .filter((item) => item.class === "X")
              .map((item) => item.sessionYear),
          ),
        ).sort((a, b) =>
          b.localeCompare(a, undefined, { numeric: true, sensitivity: "base" }),
        );

        // Use the most recent year if available
        if (uniqueYears.length > 0) {
          const mostRecentYear = uniqueYears[0];
          classX = topperData.filter(
            (item) => item.class === "X" && item.sessionYear === mostRecentYear,
          );
        }
      }

      setClassXData(classX);
    };

    fetchData();
  }, []);

  const emptyArray = [
    { name: "Student Name", division: "%", stream: "Subject" },
    { name: "Student Name", division: "%", stream: "Subject" },
    { name: "Student Name", division: "%", stream: "Subject" },
    { name: "Student Name", division: "%", stream: "Subject" },
  ];

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="row">
        {classXData.length > 0 ? (
          <Slider {...settings}>
            {classXData.map((item1, index) => (
              <div className="item" key={index}>
                <div className="topperdiv">
                  <div className="topperimages">
                    <img
                      src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item1?.attachments}`}
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/tooperpicicn.png"
                    className="img-fluid tooperpicicn"
                  />
                  <div className="topperdesc">
                    <p className="per"> {item1?.division}</p>
                    <p className="name">
                      {item1?.name} <span> </span>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <Slider {...settings}>
            {emptyArray.map((data, index) => (
              <div className="item" key={index}>
                <div className="topperdiv">
                  <div className="topperimages">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/achievement.jpg"
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/tooperpicicn.png"
                    className="img-fluid tooperpicicn"
                  />
                  <div className="topperdesc">
                    <p className="per"> {data.division}</p>
                    <p className="name">
                      {data.name} <span> </span>{" "}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    </>
  );
};

export default TopperX;
